<template>
    <div>
      <div id="map-container" ref="map"></div>
    </div>
</template>

<script>
// import mapPoint from '@/assets/mapPoint.svg'
import smallerPoint from '@/assets/smallerPoint.svg'
import point1PL from '@/assets/mapPoint1PL.svg'
import point3L from '@/assets/mapPoint3PL.svg'
import pointExpress from '@/assets/mapPointExpress.svg'
import polyline from 'google-polyline'

export default {
  name: 'HereMap',
  components: {},
  props: {
    shipments: Array,
    cardClicked: Number,
    shipmentID: String,
    selectedShipment: Object
  },
  data () {
    return {
      map: {},
      platform: {},
      router: {},
      ui: null,
      routeDecode: [],
      smallerSvg: null,
      svg1PL: null,
      svg3PL: null,
      svgExpress: null,
      route: {},
      allMarkers: []
    }
  },
  computed: {
    // filterShipments () {
    //   return this.shipments.filter(function (el) {
    //     if (this.shipmentID !== null) {
    //       return this.shipmentID === el.objectID && el.type === '1PL'
    //     } else {
    //       return el.type === '1PL'
    //     }
    //   }, { shipmentID: this.shipmentID })
    // }
  },
  methods: {
    getRoute (shipment) {
      // takes the string to be used to create the route
      let coords = polyline.decode(shipment.route)
      let routingParameters = {}
      for (let i = 0; i < coords.length; i++) {
        routingParameters.mode = 'balanced;truck'
        routingParameters.representation = 'display'
        routingParameters['waypoint' + i] = coords[i][0] + ',' + coords[i][1]
      }
      let id = shipment.objectID || shipment.id
      // the data for the creation of the route comes from the string in route
      this.router.calculateRoute(routingParameters, this.onResult.bind(null, id), this.onError)
    },
    onResult (id, result) {
      let route = result.response.route[0]
      this.drawLine({ route: route, type: '1PL', id: id })
    },
    onError (error) {
      console.log(error.message)
    },
    async drawMap () {
      if (this.shipments) {
        await this.shipments.forEach(shipment => {
          if (this.shipmentID === null || this.shipmentID === shipment.objectID) {
            if (shipment.type === '1PL') {
              this.getRoute(shipment)
              this.drawMarkers(shipment)
            } else if (shipment.type !== '2PL') {
              this.drawLine(shipment)
              this.drawMarkers(shipment)
            }
          }
        })
        if (this.allMarkers.length > 0 && this.shipmentID === null) {
          let newGroup = new window.H.map.Group()
          newGroup.addObjects(this.allMarkers)
          // this.map.addObject(group)
          this.map.getViewModel().setLookAtData({
            bounds: newGroup.getBoundingBox(),
            zoom: 10
          })
        }
      } else if (this.selectedShipment) {
        // TODO when shipment from algolia check here type
        // now only 1PL from services
        this.getRoute(this.selectedShipment)
        this.drawMarkers(this.selectedShipment)
      }
    },
    drawLine (lineObject) {
      let routeLine
      let routeLine3PL
      let routeArrows3PL
      let style = { lineWidth: 3, fillColor: 'white', strokeColor: 'rgba(255, 255, 255, 1)', lineDash: [0, 2], lineTailCap: 'arrow-tail', lineHeadCap: 'arrow-head' }

      if (lineObject.type === '1PL') {
        let routeShape = lineObject.route.shape
        let linestring = new window.H.geo.LineString()

        routeShape.forEach(function (point) {
          let parts = point.split(',')
          linestring.pushLatLngAlt(parts[0], parts[1])
        })
        routeLine = new window.H.map.Polyline(linestring, {
          style: { strokeColor: '#4CAF50', lineWidth: 3 },
          data: { id: lineObject.id }
        })
        this.map.addObject(routeLine)
        if (this.shipments) {
          this.changeColor1PL(routeLine)
        } else if (this.selectedShipment) {
          this.autoZoom(routeLine)
        }
      } else if (lineObject.type === '3PL') {
        let linestring3PL = new window.H.geo.LineString()
        for (let i = 0; i < lineObject._geoloc.length; i++) {
          linestring3PL.pushPoint({ lat: lineObject._geoloc[i].lat, lng: lineObject._geoloc[i].lng })
        }
        routeLine3PL = new window.H.map.Polyline(linestring3PL, {
          style: { strokeColor: '#9C27B0', lineWidth: 3, lineTailCap: 'arrow-tail', lineHeadCap: 'arrow-head' },
          data: { id: lineObject.objectID }
        })
        routeArrows3PL = new window.H.map.Polyline(linestring3PL, {
          style: style,
          data: { id: lineObject.objectID }
        })
        this.map.addObjects([routeLine3PL, routeArrows3PL])
        this.changeColor3PL(routeLine3PL, routeArrows3PL)
      } else if (lineObject.type === 'Express') {
        let routeLineExpress = []
        let routeArrowsExpress = []

        // for each geolog coordinates except beginning push points
        // create pairs [0,1], [0,2], [0,3] etc
        for (let i = 1; i < lineObject._geoloc.length; i++) {
          let linestringExpress = new window.H.geo.LineString()

          linestringExpress.pushPoint({ lat: lineObject._geoloc[0].lat, lng: lineObject._geoloc[0].lng })
          linestringExpress.pushPoint({ lat: lineObject._geoloc[i].lat, lng: lineObject._geoloc[i].lng })

          // for each pair from above create two new polylines, one yellow and one for arrows
          routeLineExpress[i - 1] = new window.H.map.Polyline(linestringExpress, {
            style: { strokeColor: '#FF9800', lineWidth: 3, lineTailCap: 'arrow-tail', lineHeadCap: 'arrow-head' },
            data: { id: lineObject.objectID }
          })

          routeArrowsExpress[i - 1] = new window.H.map.Polyline(linestringExpress, {
            style: style,
            data: { id: lineObject.objectID }
          })
        }

        this.map.addObjects([...routeLineExpress, ...routeArrowsExpress])
        this.changeColorExpress(routeLineExpress, routeArrowsExpress)
      }
    },
    drawMarkers (shipment) {
      if (this.smallerSvg !== null && this.svg1PL !== null && this.svg3PL !== null && this.svgExpress !== null) {
        let self = this
        let icon
        let smallerIcon = new window.H.map.DomIcon(this.smallerSvg)
        let icon1PL = new window.H.map.DomIcon(this.svg1PL)
        let icon3PL = new window.H.map.DomIcon(this.svg3PL)
        let iconExpress = new window.H.map.DomIcon(this.svgExpress)
        // the markers come from _geoloc in shipments
        let markers = []
        for (let i = 1; i < shipment._geoloc.length; i++) {
          let marker
          if (shipment.type === '1PL' || shipment.type === '2PL') {
            icon = icon1PL
          } else if (shipment.type === '3PL') {
            icon = icon3PL
          } else if (shipment.type === 'Express') {
            icon = iconExpress
          }

          marker = new window.H.map.DomMarker({
            lat: shipment._geoloc[i].lat,
            lng: shipment._geoloc[i].lng
          },
          { icon: icon })

          if (shipment.type === '1PL' || shipment.type === '2PL') {
            let marker2 = new window.H.map.DomMarker({
              lat: shipment._geoloc[i].lat,
              lng: shipment._geoloc[i].lng
            },
            { icon: icon1PL })
            this.allMarkers.push(marker2)
          }

          let bubbleContent = '<b>' + this.$i18n.t('locations.lat') + ':</b> ' + shipment._geoloc[i].lat + '\n<b>' + this.$i18n.t('locations.lng') + ':</b> ' + shipment._geoloc[i].lng
          marker.addEventListener('tap', function (evt) {
            let bubble = new window.H.ui.InfoBubble(evt.target.getGeometry(), {
              content: bubbleContent
            })
            self.ui.getBubbles().forEach(bub => self.ui.removeBubble(bub))
            self.ui.addBubble(bubble)
          }, false)
          markers.push(marker)
        }
        let smallerMarker = new window.H.map.DomMarker({
          lat: shipment._geoloc[0].lat,
          lng: shipment._geoloc[0].lng
        },
        { icon: smallerIcon })

        if (shipment.type === '1PL' || shipment.type === '2PL') {
          let smallerMarker2 = new window.H.map.DomMarker({
            lat: shipment._geoloc[0].lat,
            lng: shipment._geoloc[0].lng
          },
          { icon: smallerIcon })
          this.allMarkers.push(smallerMarker2)
        }
        let smallerMarkerContent = '<b>' + this.$i18n.t('locations.lat') + ':</b> ' + shipment._geoloc[0].lat + '\n<b>' + this.$i18n.t('locations.lng') + ':</b> ' + shipment._geoloc[0].lng
        smallerMarker.addEventListener('tap', function (evt) {
          let bubble = new window.H.ui.InfoBubble(evt.target.getGeometry(), {
            content: smallerMarkerContent
          })
          self.ui.getBubbles().forEach(bub => self.ui.removeBubble(bub))
          self.ui.addBubble(bubble)
        }, false)
        let group = new window.H.map.Group()
        group.addObjects(markers)
        group.addObject(smallerMarker)
        this.map.addObject(group)
      }
    },
    changeColor1PL (routeLine) {
      routeLine.addEventListener('tap', (evt) => {
        let currentColor = routeLine.getStyle().strokeColor
        if (evt.target.data.id === routeLine.data.id && currentColor === '#4CAF50') {
          routeLine.setStyle(routeLine.getStyle().getCopy({ strokeColor: 'red' }))
          this.$emit('routeClicked', evt.target.data.id)
          this.map.getViewModel().setLookAtData({
            bounds: routeLine.getBoundingBox(),
            zoom: 11
          })
          // console.log(routeLine.getBoundingBox())
        } else if (evt.target.data.id === routeLine.data.id && currentColor === 'red') {
          routeLine.setStyle(routeLine.getStyle().getCopy({ strokeColor: '#4CAF50' }))
          this.$emit('routeClicked', 'no route')
        }
      })

      if (this.shipmentID === routeLine.data.id) {
        routeLine.setStyle(routeLine.getStyle().getCopy({ strokeColor: 'red' }))
        this.map.getViewModel().setLookAtData({
          bounds: routeLine.getBoundingBox(),
          zoom: 11
        })
      } else if (this.shipmentID === null) {
        routeLine.setStyle(routeLine.getStyle().getCopy({ strokeColor: '#4CAF50' }))
      }
    },
    changeColor3PL (routeLine3PL, routeArrows3PL) {
      routeArrows3PL.addEventListener('tap', (evt) => {
        let currentColor = routeLine3PL.getStyle().strokeColor
        if (evt.target.data.id === routeArrows3PL.data.id && currentColor === '#9C27B0') {
          routeLine3PL.setStyle(routeLine3PL.getStyle().getCopy({ strokeColor: 'red' }))
          this.$emit('routeClicked', evt.target.data.id)
          this.map.getViewModel().setLookAtData({
            bounds: routeLine3PL.getBoundingBox()
          })
        } else if (evt.target.data.id === routeArrows3PL.data.id && currentColor === 'red') {
          routeLine3PL.setStyle(routeLine3PL.getStyle().getCopy({ strokeColor: '#9C27B0' }))
          this.$emit('routeClicked', 'no route')
        }
      })

      if (this.shipmentID === routeLine3PL.data.id) {
        routeLine3PL.setStyle(routeLine3PL.getStyle().getCopy({ strokeColor: 'red' }))
        this.map.getViewModel().setLookAtData({
          bounds: routeLine3PL.getBoundingBox()
        })
      } else if (this.shipmentID === null) {
        routeLine3PL.setStyle(routeLine3PL.getStyle().getCopy({ strokeColor: '#9C27B0' }))
      }
    },
    changeColorExpress (routeLineExpress, routeArrowsExpress) {
      for (let i = 0; i < routeLineExpress.length; i++) {
        if (this.shipmentID === routeLineExpress[i].data.id) {
          this.map.getViewModel().setLookAtData({
            bounds: routeLineExpress[i].getBoundingBox()
          })
          routeLineExpress[i].setStyle(routeLineExpress[i].getStyle().getCopy({ strokeColor: 'red' }))
        } else if (this.shipmentID === null) {
          routeLineExpress[i].setStyle(routeLineExpress[i].getStyle().getCopy({ strokeColor: '#FF9800' }))
        }

        for (let j = 0; j < routeArrowsExpress.length; j++) {
          routeArrowsExpress[j].addEventListener('tap', (evt) => {
            let currentColor = routeLineExpress[i].getStyle().strokeColor
            if (evt.target.data.id === routeArrowsExpress[i].data.id && currentColor === '#FF9800') {
              routeLineExpress[i].setStyle(routeLineExpress[i].getStyle().getCopy({ strokeColor: 'red' }))
              this.$emit('routeClicked', evt.target.data.id)
              this.map.getViewModel().setLookAtData({
                bounds: routeLineExpress[i].getBoundingBox()
              })
            } else if (evt.target.data.id === routeArrowsExpress[j].data.id && currentColor === 'red') {
              routeLineExpress[i].setStyle(routeLineExpress[i].getStyle().getCopy({ strokeColor: '#FF9800' }))
              this.$emit('routeClicked', 'no route')
            }
          })
        }
      }
    },
    autoZoom (routeLine) {
      // TODO change the zoom when routes are longer
      // now only 1PL routes in shipment detail so no long routes
      this.map.getViewModel().setLookAtData({
        bounds: routeLine.getBoundingBox(),
        zoom: 11
      })
    }
  },
  created () {
    this.platform = new window.H.service.Platform({
      apikey: 'nnuTL4coE1diqkZ9mDdzC7shaHo7hJrtZmeHfd1mRzU',
      app_code: 'PROD-de11fa5f-5a46-49b7-bdc9-b09879cdb583',
      useCIT: true,
      useHTTPS: true
    })
    // Get an instance of the routing service:
    this.router = this.platform.getRoutingService()
  },
  async mounted () {
    const mapTypes = this.platform.createDefaultLayers({ lg: this.$i18n.locale })

    this.map = new window.H.Map(
      this.$refs.map,
      mapTypes.vector.normal.map,
      {
        zoom: 7,
        center: { lat: 49.2306525, lng: 16.59019349999994 },
        pixelRatio: window.devicePixelRatio || 1
      })

    // add a resize listener to make sure that the map occupies the whole container
    window.addEventListener('resize', () => this.map.getViewPort().resize())

    this.ui = window.H.ui.UI.createDefault(this.map, mapTypes)
    let mapSettings = this.ui.getControl('mapsettings')
    let zoom = this.ui.getControl('zoom')
    let scalebar = this.ui.getControl('scalebar')

    mapSettings.setAlignment('top-left')
    zoom.setAlignment('top-left')
    scalebar.setAlignment('top-left')
    let mapEvents = new window.H.mapevents.MapEvents(this.map)
    // default map events
    let behavior = new window.H.mapevents.Behavior(mapEvents)

    this.smallerSvg = await fetch(smallerPoint).then(r => r.text())
    this.svg1PL = await fetch(point1PL).then(r => r.text())
    this.svg3PL = await fetch(point3L).then(r => r.text())
    this.svgExpress = await fetch(pointExpress).then(r => r.text())

    if (this.shipments) {
      for (let i = 0; i < this.shipments.length; i++) {
        if (this.shipments[i].type === '1PL') {
          console.log(this.shipments[i].route)
          this.routeDecode = polyline.decode(this.shipments[i].route)
        }
      }
    } else if (this.selectedShipment) {
      // TODO when data from algolia check here type of shipment
      // now only 1PL
      this.routeDecode = polyline.decode(this.selectedShipment.route)
    }
    console.log(this.routeDecode)
    this.drawMap()
  },
  watch: {
    shipmentID: function () {
      this.map.removeObjects(this.map.getObjects())
      this.drawMap()
    },
    shipments () {
      this.map.removeObjects(this.map.getObjects())
      this.drawMap()
    }
  }
}
</script>

<style lang="scss" scoped>
#map-container {
  width: 100%;
  height: calc(100vh - 220px);
}
</style>
